import ResponseRating from "../../cabinet/responses/ResponseRating";

const ModalFeedback = () => {
    return (
        <div className="modal__feedback">
            <ResponseRating />
        </div>
    );
};

export default ModalFeedback;
